<template>
  <div id="app" v-wechat-title="$route.meta.title ? $route.meta.title : '乐跳网'">
    <el-container>
      <el-header class="header" height="82px">
        <div class="header-content">
          <el-row>
            <el-col :span="5"><img class="logo" :src="require('~/assets/images/logo.png')" width="188" alt="乐跳网"
                title="乐跳网">
            </el-col>
            <el-col :span="17" v-if="roleId == 2">
              <el-menu :router="true" :default-active="activeIndex" class="header-menu" mode="horizontal">
                <el-menu-item index="JobIndex">职位管理</el-menu-item>
                <el-submenu index="ZTalentIndex">
                  <template slot="title">
                    <span>人才圈</span>
                  </template>   
                  <el-menu-item index="TalentIndex">推荐人才</el-menu-item>               
                  <el-menu-item index="TalentSearch">搜索人才</el-menu-item>
                  <el-menu-item index="HrReadResume">看过的人才</el-menu-item>
                  <el-menu-item index="HrInsteadInviteResume">我的代约</el-menu-item>
                </el-submenu>
                <el-menu-item index="HrChat">沟通</el-menu-item>
                <el-menu-item index="Interview">面试</el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="17" v-if="roleId == 1">
              &nbsp;
            </el-col>
            <el-col :span="2" v-if="token && roleId == 2">
              <el-popover placement="bottom-end" popper-class="downdrop-mycenter" width="220" :visible-arrow="false"
                trigger="hover">
                <div>
                  <ul>
                    <!-- <li>
                      <el-link href="/#/MyCenter" :underline="false">个人资料
                        <span class="link-help">基本信息、联系方式、更换公司</span></el-link>
                    </li>
                    <li>
                    <li>
                      <el-link href="/#/MessageSetting" :underline="false">消息设置
                        <span class="link-help">常用语、打招呼语</span></el-link>
                    </li>
                    <li>
                      <el-link href="/#/MyCompany" :underline="false">公司主页</el-link>
                    </li>
                    <li class="divider">
                    </li> -->
                    <li>
                      <el-link @click="logout" :underline="false">退出</el-link>
                    </li>
                  </ul>
                </div>
                <div slot="reference" class="head-image-wrap">
                  <user-avatar :src="headImage" className="useravatar-cirle-sm"></user-avatar>
                </div>
              </el-popover>
            </el-col>
            <el-col :span="2" v-if="token && roleId == 1">
              <el-popover placement="bottom-end" popper-class="downdrop-mycenter" width="220" :visible-arrow="false"
                trigger="hover">
                <div>
                  <ul>
                    <li>
                      <el-link @click="logout" :underline="false">退出</el-link>
                    </li>
                  </ul>
                </div>
                <div slot="reference" class="head-image-wrap">
                  <user-avatar :src="headImage" className="useravatar-cirle-sm"></user-avatar>
                </div>
              </el-popover>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="key" @changeMenu="onChangeMenu" @refreshUser="refreshUser"></router-view>
      <el-footer class="footer" height="30px">
        ©{{year}} 乐跳网 <a target="_blank" class="margin-l20" href="http://www.beian.miit.gov.cn/"> 浙ICP备15044165号-2</a>
        <a target="_blank" class="margin-l20"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33042102000231"> 浙公网安备 33042102000231号</a>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import {
    logout
  } from '~/api/account';
  import UserAvatar from '~/components/UserAvatar';
  export default {
    components: {
      UserAvatar
    },
    data() {
      return {
        year: new Date().getFullYear(),
        token: this.$store.getters.token,
        roleId: this.$store.getters.roleId,
        headImage: this.$store.getters.headImage,
        activeIndex: '4',
        visible: true
      };
    },
    computed: {
      key() {
        return this.$route.name ? this.$route.name + +new Date() : this.$route + +new Date();
      },
    },
    created() {},
    mounted() {
    },
    methods: {
      onChangeMenu(val) {
        this.activeIndex = val;
      },
      refreshUser(user){
        this.token = user.token;
        this.roleId = user.user_role;
        this.headImage = user.head_image;
      },
      logout() {
        logout().then(m => {
          if (m.errcode == 0) {
            this.token = '';
            this.roleId = '';
            this.headImage = '';
            this.$store.dispatch('Logout');
            if (this.$route.path == '/') {
              this.$router.go(0);
            } else {
              this.$router.push('/');
            }
          } else {
            this.$message.error(m.errmsg);
          }
        });
      }
    }
  };
</script>

<style>
  #app {
    font-family: Helvetica, sans-serif;
    text-align: center;
  }
</style>